var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('flat-pickr',{staticClass:"w-full",attrs:{"placeholder":_vm.placeholder,"disabled":_vm.isDisabled,"value":_vm.value,"config":{
    dateFormat: _vm.dateFormat,
    minDate: _vm.minValue,
    maxDate: _vm.maxValue,
    defaultHour: 0,
    altInput: true,
    altFormat: _vm.altFormat,
    enableTime: _vm.componentType === 'datetime',
    time_24hr: true,
    enableSeconds: true,
    mode: _vm.dateMode,
    onChange: _vm.onChange,
    minDate: _vm.allowPastDates ? null : 'today'
  },"name":"dob"},on:{"input":function($event){return _vm.onInput($event)}}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }